import React, { useState } from 'react';
import style from "./style.module.css";
import { getStorage } from '../../modals/Storage';

function View() {
    const [isVisible, setIsVisible] = useState(true);

    // No message -> render nothing
    if (!getStorage("app_special_message")) {
        return null;
    }

    const hideMessageView = () => {
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className={style.parentView}>
            <div className={style.contentsView}>
                {getStorage("app_special_message")}
            </div>

            <div className={style.closeBtn} onClick={hideMessageView}>
                <span className="material-symbols-outlined icon-size-s">
                    close
                </span>
            </div>
        </div>
    );
}

export default View;